import moment from "moment"

export const compareDate = (fechaServer, fecha2) =>{
    const formatF1 =  moment(fechaServer, "DD/MM/YYYY HH:mm:ss").format('YYYY-MM-DD HH:mm:ss')
    const formatF2 =  moment(fecha2, "YYYY-MM-DDTHH:mm:ss").format('YYYY-MM-DD HH:mm:ss')
    let f1 = moment(formatF1)
    let f2 = moment(formatF2)

    if(f1.isSameOrAfter(f2)){
        return "terminado"
    }
    return "noTerminado"
}